import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, CircularProgress } from '@mui/material';
import { People as PeopleIcon } from '@mui/icons-material';
import ContactList from './ContactList';
import axiosInstance from '../../utils/axiosConfig';

const CustomerList: React.FC = () => {
  const [customerCount, setCustomerCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCustomerCount();
  }, []);

  const fetchCustomerCount = async () => {
    try {
      const response = await axiosInstance.get('/contacts', {
        params: { type: 'customer', page: 1, limit: 1 }
      });
      const count = response.data.pagination?.total || 0;
      setCustomerCount(count);
    } catch (error) {
      console.error('Error fetching customer count:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
    }}>
      <Box sx={{ p: 2 }}>
        <Card sx={{
          mb: 3,
          background: 'linear-gradient(120deg, #1976d2 0%, #2196f3 100%)',
          color: 'white',
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
        }}>
          <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 2.5 }}>
            <PeopleIcon sx={{ fontSize: 48 }} />
            <Box>
              <Typography variant="h6" sx={{ mb: 0.5 }}>إجمالي العملاء</Typography>
              {loading ? (
                <CircularProgress size={24} sx={{ color: 'white' }} />
              ) : (
                <Typography variant="h3" sx={{ fontWeight: 'bold' }}>{customerCount}</Typography>
              )}
            </Box>
          </CardContent>
        </Card>
        <ContactList defaultType="customer" hideTypeFilter />
      </Box>
    </Box>
  );
};

export default CustomerList;